import React, {useState} from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './_style.scss';

// Components
import UniversalLink from "§/src/utils/UniversalLink"
import ArrowRight from "§/src/images/svg/arrow-right.svg"


const ImageText = (props) => {

  var {
    titolo,
    testo,
    cta,
    ctaTesto,
    ctaSelf,
    image,
    classeTitolo,
    classeTesto,
    reverse,
    background,
    ...aboutUsProps
  } = props.data;

   const compClassName = 'image-text';
   const compClass = props?.className !== undefined ? compClassName + ' ' + props?.className : compClassName;

  return (
    <div comp={compClassName} className={compClass}>
      <div className={'container d-flex align-items-center ' + (reverse ? 'flex-column-reverse flex-lg-row-reverse' : 'flex-column flex-md-row') + (background ? ' position-relative' : '')}>
        {background &&
          <figure className='background position-absolute'>
            <GatsbyImage
              className="bg-image"
              image={getImage(background)}
              objectFit="cover"
              fit="cover"
              alt={background?.altText || 'image-text background'}
            />
          </figure>
        }
        <div className='col image'>
          {image && (
              <GatsbyImage
                className="sw-image"
                image={getImage(image)}
                objectFit="cover"
                fit="cover"
                alt={image?.altText || 'image-text image'}
              />
          )}
        </div>
        <div className='col text'>
          {titolo && (
          <h2 className={classeTitolo}>{titolo}</h2>
          )}
          {testo && (
            <p className={classeTesto}>{testo}</p>
          )}
          {cta && (
            <UniversalLink
              id="bottom-cta"
              className="btn btn-link p-0"
              rel="veneziaunica"
              to={ cta.url }
              title={ cta.title }
              target={ ctaSelf ? "_self" : "_blank" }
            >
              <span>{ctaTesto}</span>
              <ArrowRight/>
            </UniversalLink>
          )}
        </div>
      </div>
    </div>
  );

};

export default ImageText;
